import styled from 'styled-components'

export const DocumentNo = styled.div`
  font-size: 12px;
  color: #727e7c;
  margin-top: 16px;
`
export const AdvertLink = styled.a`
  border: 1px #c2cac8 solid;
  border-radius: 8px;
  overflow: hidden;
  display: inline-flex;
  justify-content: center;
  width: 100%;
  img {
    width: 100%;
  }
`

export const AdvertSliderWrapper = styled.div`
  max-width: 1120px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`
